import React, { useEffect, useState } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { SlGraph } from "react-icons/sl";
import SquareAvatar from "../../commonComponent/SquareAvatar";
import { Doughnut } from "react-chartjs-2";
// import AppointmentRequests from "./AppointmentRequests";
import ReactDatePicker from "react-datepicker";
import {
  getAllSessionsandEvents,
  getClientDatabyTeamId,
  getGenderDatabyTeamId,
} from "../../services/CareTeam";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { deleteSessionService, getActiveProgramById } from "../../services/ActivePrograms";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../commonComponent/DeleteModal";
import { format24Time, showToastError, showToastSuccess } from "../../Utils/Helper";
import { AddReminder } from "../../services/ReminderService";
import { toastMsg } from "../../Utils/AllConstant";

const AppointmentPatientSection = ({ teamData }) => {
  const navigate = useNavigate();
  const [genderDate, setGenderDate] = useState(new Date());
  const [clientDate, setClientDate] = useState(new Date());
  const [appointmentList, setAppointmentList] = useState([]);
  const [program, setProgramDetails] = useState();
  const [session, setSession] = useState();
  const [sessionId, setSessionId] = useState();
  const [programId, setProgramId] = useState("");
  const [genderData, setGenderData] = useState({
    Male: 0,
    Female: 0,
  });
  const [clientData, setClientData] = useState({
    newClient: 0,
    oldClient: 0,
  });

  
  const handleConversion = (reminder) => {
    let time = format24Time(reminder.startTime) + ":00.000+05:30";
    return time;
  };

  const setReminder = async (reminder) => {
    const reminderTitle = `Session Reminder ${reminder.title} at ${moment(
      new Date(reminder.startTime)
    ).format("hh:mm a")}`;
    let params = {
      dateTime: handleConversion(reminder),
      title: reminderTitle, //Group session Appointment with full name at 11:40
      type: "reminder",
      isCompleted: [],
    };
    try {
      const response = await AddReminder(params);
      if (response.status === 200) {
        showToastSuccess("Reminder Created");
      } else {
        showToastError(
          response?.data || response.message || toastMsg.errorMssg
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error?.data?.message || toastMsg.errorMssg
      );
    }
  };



  const deleteSession = async () => {
    try {
      const response = await deleteSessionService(sessionId, programId);
      if (response) {
        showToastSuccess(response?.data || "Session deleted successfully.");
        getAllSessionsEvents()
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const getActiveProgramByIds = async (programId, session, viewSession) => {
    let programDetails;
    try {
      const response = await getActiveProgramById(programId);
      if (response.status === 200) {
        programDetails = response?.data?.data[0];
        setProgramDetails(programDetails);
        setSession(session);
        if (programDetails && session && viewSession) {
          navigate("/activeprogram", {
            state: {
              program: programDetails,
              isFromCreate: false,
              isRedirectedFromDashboard: true,
              session: session,
              viewSession: viewSession,
            },
          });
        }
        if (programDetails && !session && !viewSession) {
          navigate("/activeprogram", {
            state: {
              program: programDetails,
              isFromCreate: false,
              isRedirectedFromDashboard: true,
              session: session,
              viewSession: viewSession,
            },
          });
        }
      } else {
        console.log(response?.data || response.message);
      }
    } catch (error) {
      console.log(error?.data || error.message);
    }
  };

  const getAllSessionsEvents = async () => {
    try {
      const result = await getAllSessionsandEvents("all", teamData._id);

      if (result.status !== 200) return;
      setAppointmentList(result.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllSessionsEvents();
  }, []);

  useEffect(() => {
    const getClientdata = async () => {
      try {
        const result = await getClientDatabyTeamId(
          moment(clientDate).format("yyyy"),
          teamData._id
        );

        if (result.status !== 200) return;
        setClientData(result.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    const getGenderdata = async () => {
      try {
        const result = await getGenderDatabyTeamId(
          moment(genderDate).format("yyyy"),
          teamData._id
        );

        if (result.status !== 200) return;
        setGenderData(result.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    getClientdata();
    getGenderdata();
  }, [genderDate, clientDate]);

  const getBackgroundColor = (values) => {
    const areAllZero = values.every((value) => value === '0%');
    return areAllZero ? "rgb(169, 169, 169)" : ["rgb(7, 169, 240)", "rgb(202, 121, 198)",  "rgb(255, 165, 0)", "rgb(128, 0, 128)", "rgb(0, 128, 0)"];
  }
  
  const getBorderColor = (values) => {
    const areAllZero = values.every((value) => value === '0%');
    return areAllZero ? "rgb(169, 169, 169)" : ["rgb(7, 169, 240)", "rgb(202, 121, 198)",  "rgb(255, 165, 0)", "rgb(128, 0, 128)", "rgb(0, 128, 0)"];
  }

  const getDataArray = (values,obj) => {
    const areAllZero = values.every((value) => value === '0%')
    return areAllZero ? [100] : Object.values(obj).map(value => value.toString().split("%")[0])
  }

  const getLabelArray = (values,obj) => {
    const areAllZero = values.every((value) => value === '0%')
    return areAllZero ? ["No data"] : Object.keys(obj).map(value => value)
  }

  const data = {
    labels: getLabelArray(Object.values(genderData),genderData),
    datasets: [
      {
        label: "# of Votes",
        data: getDataArray(Object.values(genderData),genderData),
        backgroundColor: getBackgroundColor(Object.values(genderData)),
        borderColor: getBorderColor(Object.values(genderData)),
        borderWidth: 1,
      },
    ],
  };




  return (
    <>
      <div className="row mt-5">
        <div className="col-md-6">
          <p className="post_heading">
            Appointment Request{" "}
            <span className="float-end appointment_viewall cursor-pointer">
              View All <MdArrowForwardIos />
            </span>
          </p>

          <div
            className="caret_appointment6 shadow my-4 py-1 overflow-x-hidden overflow-y-scroll Dash"
            style={{ height: "600px" }}
          >
            {appointmentList.map((item) => (
              <div className="appointment_request9 mt-3" key={item._id}>
                <div className=" row">
                  {/* <div className="col-md-2 text-center">
                    <SquareAvatar
                      src={"images/avatar.png"}
                      className="imgsize ms-4"
                    />
                  </div> */}
                  <div className="col-md-12">
                    <div className="d-flex  px-2">
                      <span className="flex-1 resFont fw-semibold text-truncate ">{item.title}</span>
                      <div className="d-flex align-items-center flex-0">
                      <button className="btn btn-sm btn-outline-success">
                        Start Session
                      </button>
                      <Dropdown
                        style={{ width: "max-content", height: "max-content" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Dropdown.Toggle
                          // onClick={(e)=>e.stopPropagation()}
                          variant="transparent"
                          className="custom d-flex align-content-center "
                          id="dropdown-basic"
                          style={{
                            color: "rgba(201, 204, 206, 1)",
                          }}
                        >
                          <BsThreeDotsVertical />
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          style={{ zIndex: "1000" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Dropdown.Item
                          onClick={() => {
                            getActiveProgramByIds(
                              item.programId,
                              item,
                              true
                            );
                            setSession(item);
                          }}
                          >
                            View session
                          </Dropdown.Item>
                          <Dropdown.Item
                          onClick={() => {
                            setReminder(item)
                          }}
                          >
                            Set reminder
                          </Dropdown.Item>
                          <Dropdown.Item
                          onClick={() => {
                            getActiveProgramByIds(item.programId);
                            setSession(item);
                          }}
                          >
                            Edit session
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                          // onClick={() => {
                          //   getActiveProgramByIds(session.programId, session);
                          //   setModalShow(true);
                          //   setOperation("add");
                          // }}
                          >
                            Write Notes
                          </Dropdown.Item> */}
                          {/* <Dropdown.Item
                            href="#/action-4"
                            data-bs-toggle="modal"
                            data-bs-target="#shareModal"
                          >
                            Share session
                          </Dropdown.Item> */}
                          <Dropdown.Item
                            href="#/action-5"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteSession"
                            onClick={() => {
                              setSessionId(item._id);
                              setProgramId(item.programId);
                            }}
                          >
                            Delete session
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      </div>
                      <DeleteModal
                      title={"Delete"}
                      content1={"Are you sure you want to delete"}
                      content2={"this Session?"}
                      modalId={"deleteSession"}
                      button2={"No"}
                      button1={"Yes"}
                      onDelete={() => deleteSession()}
                    />
                    </div>
                    <p className="resFont px-2">
                      {moment(new Date(item?.startTime)).format(
                        "dddd, D MMMM H:mm"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-md-6">
          <div className="post_heading px-3 d-flex justify-content-between ">
            <span>Patients </span>
            <span className="text-muted float-end">
              <ReactDatePicker
                className="bg-transparent text-end fw-semibold text-black-50 pointer datePickerStyles"
                selected={clientDate}
                onChange={(date) => setClientDate(date)}
                showYearPicker
                dateFormat="yyyy"
              />
            </span>
          </div>
          <div className="caret_appointment6 shadow mt-4 pt-1 pe-4 pb-3">
            <div className="appointment_request9 mt-3 ">
              <div className=" row">
                <div className="col-md-2 text-center">
                  <SquareAvatar
                    src={"images/new_patient.png"}
                    className="imgsize ms-4"
                  />
                </div>
                <div className="col-md-10">
                  <h4 className=" headFont ">
                    {clientData?.newClient}
                    <span className="float-end mt-2">
                      <SlGraph /> 15%
                    </span>
                  </h4>
                  <h6 className="text-muted mb-3">New Patient</h6>
                </div>
              </div>
            </div>

            <div className="appointment_request9 mt-3 ">
              <div className=" row">
                <div className="col-md-2 text-center">
                  <SquareAvatar
                    src={"images/old_patient.png"}
                    className="imgsize ms-4"
                  />
                </div>
                <div className="col-md-10">
                  <h4 className=" headFont ">
                    {clientData?.oldClient}
                    <span className="float-end mt-2">
                      <SlGraph /> 15%
                    </span>
                  </h4>
                  <h6 className="text-muted mb-3">Old Patient</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="post_heading px-3 d-flex justify-content-between  mt-4">
            <span>Gender </span>
            <span className="text-muted float-end">
              {" "}
              <ReactDatePicker
                className="border-0 bg-transparent text-end fw-semibold text-black-50 pointer datePickerStyles"
                selected={genderDate}
                onChange={(date) => setGenderDate(date)}
                showYearPicker
                dateFormat="yyyy"
              />
            </span>
          </div>
          <div
            className="caret_appointment6 shadow mt-4 px-4 py-4"
            style={{ height: "289px" }}
          >
            <Doughnut
              data={data}
              height={"100%"}
              options={{ maintainAspectRatio: false }}
            />
          </div>
        </div>
      </div>
      {/* <AppointmentRequests /> */}
    </>
  );
};

export default AppointmentPatientSection;
